import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hasAnyExtraAttribute', pure: true })
export class HasAnyExtraAttributePipe implements PipeTransform {
  transform(extraAttributes: any): boolean {
    return extraAttributes && Object.values(extraAttributes).some(value => !!value);
  }
} 